import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { darkPurple, dimGrey } from '../../../mainTheme';

interface TabsEmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

const TabsEmptyState: React.FC<TabsEmptyStateProps> = ({
  icon,
  title,
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box sx={{ mb: 2, color: 'text.secondary' }}>{icon}</Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: darkPurple,
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.2px',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: dimGrey,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.2px',
        }}
      >
        {description}
      </Typography>
      {buttonText && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          color="secondary"
          onClick={onButtonClick}
          sx={{
            height: '40px',
            mt: '24px',
          }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default TabsEmptyState;
